import { Component, OnInit, ViewChild } from "@angular/core";
import { ProductionTechnologiesRecipes } from "src/app/services/service/DataProviders/ProductionTechnologiesRecipes";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { ArrayHelperService } from "src/app/services/common/array-helper.service";
import * as _ from "lodash";
import { LogisticsInventoryStores } from "src/app/services/service/DataProviders/LogisticsInventoryStores";
import { ProductionShopFloorWorkOrders } from "src/app/services/service/DataProviders/ProductionShopFloorWorkOrders";
import { ClrWizard, ClrWizardPage } from "@clr/angular";
import { Subproducts } from "src/app/main-functions/subproducts";
import { NotificationService } from "src/app/services/notification.service";
import { GeneralDocumentTypes } from "src/app/services/service/DataProviders/GeneralDocumentTypes";
import { SettingsService } from "src/app/services/settings.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "subproducts",
  templateUrl: "./subproducts.component.html",
  styleUrls: ["./subproducts.component.scss"],
})
export class SubproductComponent implements OnInit {
  @ViewChild("wizardxl") wizard: ClrWizard;

  @ViewChild("loadPoPage") loadPoPage: ClrWizardPage;
  @ViewChild("checkRecipePage") checkRecipePage: ClrWizardPage;
  @ViewChild("settings") settingsPage: ClrWizardPage;

  xlOpen: boolean = true;
  public processRecipe = false;
  public id: string;

  public poList = [];
  public productionOrder = null;
  public tree: any[] = [];

  public filteredRecepies: any[] = [];
  public filteredSelected: any[] = [];

  public recepiesToProcess: any[] = [];
  public recepiesToProcessSelected: any[] = [];

  public disableNextToStepThree = true;

  public formInitialValues = {
    take: 10,
  };
  public filterForm: FormGroup;
  public filterPoForm: FormGroup;

  public documentTypeOptions = [];
  public storeOptions = [];
  public stateOptions = [
    {
      state: "New",
      name: "Нов",
    },
    { state: "Planned", name: "Планиран" },
    { state: "FirmPlanned", name: "Потвърден" },
    { state: "Released", name: "Пуснат" },
  ];
  public userStateOptions = [];

  public disableProcessButton: Boolean = false;
  //result
  public executionLog;

  //settings
  public settingsForm: FormGroup = new FormGroup({
    status: new FormControl(this.stateOptions[0].name, [
      Validators.minLength(3),
    ]),
    userStatus: new FormControl(null, []),
    linkParent: new FormControl(true, [Validators.required]),
    sumQuantities: new FormControl(false, []),
    group: new FormControl("false", [Validators.required]),
    productsStore: new FormControl(null, [Validators.minLength(4)]),
    documentType: new FormControl(null, [Validators.minLength(4)]),
    materialsStore: new FormControl(null, [Validators.minLength(4)]),
  });

  //substitude
  public substitude;
  public substitudesArray: Array<any> = [];
  saveSubstitude(subsObj) {
    let { subs, idx } = subsObj;

    if (!_.isNull(idx) && idx != undefined) {
      this.substitudesArray[idx] = _.clone(subs);
      return true;
    }

    if (!subs.autoAdded) {
      this.substitudesArray.push(_.clone(subs));
    } else {
      let res = _.find(this.substitudesArray, function (s) {
        let sameProducts =
          _.get(s, "source.productName") == subs.source.productName &&
          _.get(s, "replace.productName") == subs.replace.productName &&
          _.get(s, "replace.storeName") == subs.replace.storeName;

        //количество ако е null не позволява да се добавя
        //TODO да се имплементират и проверки за количество
        return _.isEqual(s, subs);
      });

      if (!res) {
        this.substitudesArray.push(_.clone(subs));
      }
    }
  }

  constructor(
    private recepieService: ProductionTechnologiesRecipes,
    private storeService: LogisticsInventoryStores,
    private woService: ProductionShopFloorWorkOrders,
    private subproductsService: Subproducts,
    private notificationService: NotificationService,
    private documentTypeService: GeneralDocumentTypes,
    private settingService: SettingsService,
    private route: ActivatedRoute,
  ) {
    this.createFilterForm();
    this.createFilterPoForm();

    setTimeout(() => {
      if(this.settingService.tenant.name === 'BIOFRESH') {
        this.settingsForm.setValue({
          status: this.stateOptions[0],
          userStatus: null,
          linkParent: false,
          sumQuantities: true,
          group: 'true',
          productsStore: null,
          documentType: null,
          materialsStore: null,
        });
      }

      // къстъм за SmartPowerGrid
      if( [
        'SmartPowerGrid Test',
        'SmartPowerGrid',
      ].includes(this.settingService.tenant.name)) {

        let defaultDocumentType = null;
        //ПП Полуфабрикат
        const defaultDocumentTypeId = '3f4e3269-5183-4d02-bf67-5e580d2927d7'
        const defaultDocumentTypeName = 'ПП Полуфабрикат';
        for(let i = 0; i < this.documentTypeOptions.length; i++) {
          if(this.documentTypeOptions[i].TypeName?.BG == defaultDocumentTypeName) {
            defaultDocumentType = this.documentTypeOptions[i].TypeName?.BG;
            break;
          }
        }

        this.settingsForm.setValue({
          status: this.stateOptions[3].name,
          userStatus: null,
          linkParent: true,
          sumQuantities: false,
          group: 'false',
          productsStore: null,
          documentType: defaultDocumentType,
          materialsStore: null,
        });
      }

      // къстъм за Реалмет
      if( [
        'Realmet',
        'Realmet Test',
      ].includes(this.settingService.tenant.name)) {
        console.log('documentType', this.documentTypeOptions);

        let defaultDocumentType = null;
        //ПП Полуфабрикат
        const defaultDocumentTypeId = '867ca2a6-e690-466d-84c9-c30fa155ec41'
        const defaultDocumentTypeName = 'ПП Полуфабрикат';
        for(let i = 0; i < this.documentTypeOptions.length; i++) {
          // if(this.documentTypeOptions[i].Id == defaultDocumentTypeId) {
          //   defaultDocumentType = this.documentTypeOptions[i].TypeName?.BG;
          //   break;
          // }
          // търсим по име защото в двете бази са различни id-та
          if(this.documentTypeOptions[i].TypeName?.BG == defaultDocumentTypeName) {
            defaultDocumentType = this.documentTypeOptions[i].TypeName?.BG;
            break;
          }
        }

        let defaultUserStatus = null;
        // ПС В производство
        if(!_.isNull(defaultDocumentType)) {
          for(let i = 0; i < this.documentTypeOptions.length; i++) {
            if(this.documentTypeOptions[i].TypeName?.BG == defaultDocumentTypeName) {
              if(_.isArray(this.documentTypeOptions[i].UserStatuses)) {
                for(let j = 0; j < this.documentTypeOptions[i].UserStatuses.length; j++) {
                  if(this.documentTypeOptions[i].UserStatuses[j].UserStatusName.BG == 'В производство') {
                    defaultUserStatus = this.documentTypeOptions[i].UserStatuses[j].UserStatusName.BG;
                    break;
                  }
                }
              }
              break;
            }
          }
        }

        this.settingsForm.setValue({
          status: this.stateOptions[3].name,
          userStatus: defaultUserStatus,
          linkParent: true,
          sumQuantities: false,
          group: 'false',
          productsStore: null,
          documentType: defaultDocumentType,
          materialsStore: null,
        });
      }
      this.fillUserStatuses();
    }, 1000);
  }

  public async startProcessing() {
    this.disableProcessButton = true;
    await this.subproductsService.processList(
      this.tree,
      this.settingsForm,
      this.storeOptions,
      this.documentTypeOptions,
      this.productionOrder
    );
    this.disableProcessButton = false;
  }

  ngOnInit(): void {
    // this.loadRecepies();
    this.loadStores();
    this.loadDocumentTypes();
    this.executionLog = this.subproductsService.subscribeForLog();

    this.route.paramMap.subscribe(params => {
      this.id = params.get('id'); // Retrieve the optional 'id' parameter
      if(!_.isNull(this.id)) {
        this.loadPoOrders();
      }
    });

    // Add onChange listener for status field
    this.settingsForm.get('status').valueChanges.subscribe(value => {
      this.fillUserStatuses();
    });
    this.settingsForm.get('documentType').valueChanges.subscribe(value => {
      this.fillUserStatuses();
    });
  }

  fillUserStatuses() {
    setTimeout(() => {
      this.userStateOptions = [];
      let documentType = this.settingsForm.value.documentType;
      let status = this.settingsForm.value.status;

      const systemStatus = _.find(this.stateOptions, function(o) {
        return o.name === status;
      });

      if (documentType && systemStatus) {
        let self = this;
        let docType = _.find(this.documentTypeOptions, function (o) {
          return _.get(o, "TypeName.BG") === documentType;
        });

        if (!_.isUndefined(docType) && _.isArray(docType.UserStatuses)) {
          this.userStateOptions = _.filter(docType.UserStatuses, function (o) {
            return o.State == systemStatus.state;
          });

          this.userStateOptions = _.sortBy(this.userStateOptions, 'DisplayOrder');
        }
      }

      // ако няма статуси избираме първия по подразбиране
      if (_.isEmpty(this.userStateOptions)) {
        this.settingsForm.patchValue({ userStatus: null });
      } else {
        this.settingsForm.patchValue({
          userStatus: this.userStateOptions[0].UserStatusName.BG,
        });
      }
    }, 100);
  }

  loadStores() {
    let call = JSON.parse(JSON.stringify(this.storeService.stateTemplate));
    call.take = 1000;
    this.storeService.filterStores(call).subscribe((res: any) => {
      this.storeOptions = res.value;
    });
  }

  loadDocumentTypes() {
    let call = JSON.parse(JSON.stringify(this.documentTypeService.stateTemplate));

    call.expand = ['UserStatuses'];

    call.filter.filters.push(
      {
        field: 'EntityName',
        operator: 'eq',
        value: "'Prd_Work_Orders'",
      }
    );
    call.take = 1000;
    this.documentTypeService.filterStores(call).subscribe((res: any) => {
      this.documentTypeOptions = res.value;
    });
  }

  loadRecepies() {
    let filter = this.buildFilter();
    this.recepieService.filterRecipeies(filter).subscribe(
      (res: any) => {
        let recipies = res.value;

        recipies.forEach((v, idx) => {
          recipies[idx].Ingredients = _.sortBy(
            recipies[idx].Ingredients,
            "LineOrd"
          );
        });

        this.filteredRecepies = recipies;
      },
      (error) => console.error(error)
    );
  }

  loadPoOrders() {
    this.processRecipe = false;
    this.disableNextToStepThree = true;
    let filter = this.buildPoFilter();
    this.woService.filter(filter).subscribe(
      (res: any) => {
        if (!_.isArray(res.value) || res.value.length == 0) {
          alert("Не е намерено ПН");
          return;
        }

        this.recepiesToProcess = [];

        if(res.value.length == 1) {
          this.selectPoFromMultiple(res.value[0]);
        }
        else {
          this.poList = res.value;
        }
      },
      (error) => console.error(error)
    );
  }

  selectPoFromMultiple(po) {
    this.productionOrder = po;
    this.poList = [];
    this.loadPoOrder();
  }

  private loadPoOrder() {
    for (let i = 0; i < this.productionOrder.Items.length; i++) {
      if (!_.isNull(this.productionOrder.Items[i].Recipe)) {
        this.recepiesToProcess.push(this.productionOrder.Items[i]);
      }
    }

    this.processRecipe = true;
    this.loadPoPage.completed = true;
    this.jumpTo(this.checkRecipePage);

    let loadingComplete = null;
    let self = this;

    this.notificationService.getLoading$().subscribe((e) => {
      if (e) {
        if (!_.isNull(loadingComplete)) {
          clearTimeout(loadingComplete);
        }
      } else {
        loadingComplete = setTimeout(
          () => (self.disableNextToStepThree = false),
          200
        );
      }
    });
  }

  public jumpTo(page: ClrWizardPage) {
    if (page) {
      this.wizard.navService.currentPage = page;
    } else {
      this.wizard.navService.setLastEnabledPageCurrent();
    }
    this.wizard.open();
  }

  private createFilterForm() {
    this.filterForm = new FormGroup({
      Name: new FormControl("количка", [Validators.required]), //ТОДО махни стойността
      take: new FormControl(this.formInitialValues.take, [
        Validators.required,
        Validators.min(1),
        Validators.pattern(/^[0-9]\d*$/),
      ]),
      Store: new FormControl("", [Validators.minLength(4)]),
      ReleaseDate: new FormControl(),
      ExpiryDate: new FormControl(),
    });
  }

  private createFilterPoForm() {
    this.filterPoForm = new FormGroup({
      DocumentNo: new FormControl("", [Validators.required]), //ТОДО махни стойността
    });
  }

  buildFilter() {
    let call = JSON.parse(JSON.stringify(this.recepieService.stateTemplate));

    let nameFilter = {
      Name: "contains",
      ReleaseDate: "ge",
      ExpiryDate: "le",
    };

    for (const property in nameFilter) {
      let value = this.filterForm.value[property];

      if (!_.isEmpty(this.filterForm.value[property])) {
        if (property == "ReleaseDate" || property == "ExpiryDate") {
          //преработвам датата в формат
          let date = value.split(".");
          value = date[2] + "-" + date[1] + "-" + date[0] + "T00:00:00.000Z";
        }

        call.filter.filters.push({
          field: property,
          operator: nameFilter[property],
          value: value,
        });
      }
    }

    //филтър склад
    if (!_.isEmpty(this.filterForm.value.Store)) {
      let self = this;
      let store = _.find(this.storeOptions, function (o) {
        return _.get(o, "Name.BG") === self.filterForm.value.Store;
      });
      call.filter.filters.push({
        field: "Store",
        operator: "eq",
        value: "'Logistics_Inventory_Stores(" + store.Id + ")'",
      });
    }

    call.take = this.filterForm.value.take;

    return call;
  }

  buildPoFilter() {
    let call = JSON.parse(JSON.stringify(this.woService.stateTemplate));

    let nameFilter = {
      DocumentNo: "eq",
    };

    for (const property in nameFilter) {
      let value = this.filterPoForm.value[property];

      if (!_.isEmpty(this.filterPoForm.value[property])) {
        call.filter.filters.push({
          field: property,
          operator: nameFilter[property],
          value: "'" + value + "'",
        });
      }
    }

    //филтър склад
    if (!_.isEmpty(this.filterForm.value.Store)) {
      let self = this;
      let store = _.find(this.storeOptions, function (o) {
        return _.get(o, "Name.BG") === self.filterForm.value.Store;
      });
      call.filter.filters.push({
        field: "Store",
        operator: "eq",
        value: "'Logistics_Inventory_Stores(" + store.Id + ")'",
      });
    }

    call.take = this.filterForm.value.take;

    if(!_.isNull(this.id)) {
      // филтрирам по id
      call = JSON.parse(JSON.stringify(this.woService.stateTemplate));
      let filter = {
        field: "Id",
        operator: "eq",
        value: this.id,
      };
      call.filter.filters.push(filter);
      call.take = 1;
    }

    return call;
  }

  resetForm() {
    this.filterForm.reset();
    this.createFilterForm();
  }

  resetPoForm() {
    this.filterPoForm.reset();
    this.createFilterPoForm();
  }

  addRecipes() {
    this.recepiesToProcess = ArrayHelperService.unique(
      [...this.recepiesToProcess, ...this.filteredSelected],
      "Id"
    );
    this.filteredRecepies = ArrayHelperService.remove(
      this.filteredRecepies,
      this.recepiesToProcess,
      "Id"
    );
    this.filteredSelected = [];
  }

  removeFiltered() {
    this.filteredRecepies = ArrayHelperService.remove(
      this.filteredRecepies,
      this.filteredSelected,
      "Id"
    );
    this.filteredSelected = [];
  }

  removeRecepiesToProcess() {
    this.filteredRecepies = ArrayHelperService.unique(
      [...this.filteredRecepies, ...this.recepiesToProcessSelected],
      "Id"
    );
    this.recepiesToProcess = ArrayHelperService.remove(
      this.recepiesToProcess,
      this.recepiesToProcessSelected,
      "Id"
    );
    this.recepiesToProcessSelected = [];
  }
}
